import Vue from 'vue'
import moment from 'moment'
import 'moment/locale/zh-cn'

moment.locale('zh-cn')

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断
  return intPartFormat
})

Vue.filter('dayjs', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  if (!dataStr) {
    return
  }
  return moment(dataStr).format(pattern)
})

Vue.filter('day_hour', function (dataStr, pattern = 'YYYY-MM-DD HH:mm') {
  return moment(dataStr).format(pattern)
})

Vue.filter('dateFormat', function (dataStr, pattern = 'YYYY-MM-DD') {
  return moment(dataStr).format(pattern)
})

Vue.filter('dateChineseFormat', function (dataStr, pattern = 'YYYY年MM月DD日') {
  return moment(dataStr).format(pattern)
})

Vue.filter('moment', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

/**
 * 从此刻到过去多少天
 */
Vue.filter('fromNow', function (dataStr, pattern = 'YYYY-MM-DD') {
  const fromNowCount = moment().diff(moment(dataStr), 'days');
  return fromNowCount == 0 ? 1 : fromNowCount+1;
})

/**
 * 将座机号码
 */
Vue.filter('calledNumberFormat', function (phone) {
  // 确保输入是字符串，并且长度符合预期
  if (typeof phone === 'string' && phone.length === 11 && phone.startsWith('020')) {
    return `${phone.slice(0, 3)}-${phone.slice(3)}`
  }
  return phone // 如果不符合格式，返回原始值
})

/**
 * 将英文逗号转换为中文分号
 */
Vue.filter('replaceCommaWithSemicolon', function (content) {
  return content.replace(/,/g, '；');
})